import { ProviderClient } from '../../abstract/provider.client'
import { ProviderAiCommon } from '../common'

export const ProviderAiClient: ProviderClient = {
  key: ProviderAiCommon.key,
  description: {
    icon: <i className="las la-robot" style={{ fontSize: '20px' }}></i>,
    label: 'Ai',
    triggers: [],
    actions: [
      {
        key: 'generateText',
        label: 'Ask a Question',
        input: [
          {
            key: 'prompt',
            type: 'string',
          },
        ],
        output: [{ key: 'response', type: 'string' }],
      },
    ],
  },
}
